module.exports = __webpack_public_path__ + "img/m-banner-rvzldswd-pl-PL.e2a3d6bc.jpg";